import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const OPTION = 'option'
export const COUNT = 'count'
export const COMPLETES = 'completes'
export const SCREENED = 'screened'
export const QUALITY_SCREENED = 'quality_screened'
export const QUOTA_FULL = 'quota-full'
export const DROPOUT = 'dropout'
export const STARTS = 'starts'
export const COMPLETE_RATE = 'complete-rate'
export const INCIDENCE_RATE = 'incidence-rate'
export const DROPOUT_RATE = 'dropout-rate'
export const LOI = 'LOI'

export default {
  [PORTUGUESE]: {
    [OPTION]: 'Opção',
    [COUNT]: 'Contagem',
    [COMPLETES]: 'Completas',
    [SCREENED]: 'Screened',
    [QUALITY_SCREENED]: 'Filtro por Qualidade',
    [QUOTA_FULL]: 'Cota Completa',
    [DROPOUT]: 'Desistências',
    [STARTS]: 'Entradas',
    [COMPLETE_RATE]: 'Taxa de Completa',
    [INCIDENCE_RATE]: 'Taxa de Incidência',
    [DROPOUT_RATE]: 'Taxa de Desistência',
    [LOI]: 'Duração',
  },

  [ENGLISH]: {
    [OPTION]: 'Option',
    [COUNT]: 'Count',
    [COMPLETES]: 'Completes',
    [SCREENED]: 'Screened',
    [QUALITY_SCREENED]: 'Quality Screened',
    [QUOTA_FULL]: 'Quota Full',
    [DROPOUT]: 'Dropout',
    [STARTS]: 'Starts',
    [COMPLETE_RATE]: 'Complete Rate',
    [INCIDENCE_RATE]: 'Incidence Rate',
    [DROPOUT_RATE]: 'Dropout Rate',
    [LOI]: 'LOI',
  },

  [SPANISH]: {
    [OPTION]: 'Opción',
    [COUNT]: 'Puntaje',
    [COMPLETES]: 'Completa',
    [SCREENED]: 'Screened',
    [QUALITY_SCREENED]: 'Filtro de calidad',
    [QUOTA_FULL]: 'Cuota Completa',
    [DROPOUT]: 'Abandonos',
    [STARTS]: 'Entradas',
    [COMPLETE_RATE]: 'Tasa de Completa',
    [INCIDENCE_RATE]: 'Tasa de Incidencia',
    [DROPOUT_RATE]: 'Tasa de Abandonos',
    [LOI]: 'Duración',
  },
}
